<template lang="pug">
	div.sidebar-container(style="height: 100%")
		div(v-if="!userSubscribed()" style="height: 100%")
			no-ssr
				aside.ads
					section.sidebar-large(style="margin-bottom: 30px")
						sfc-dfp-ad(ad-unit="savingforcollege_other_right_wide_skyscraper" sizes="[[160,600],[300, 600],[300, 250]]")
					section.text-ads
						div
							sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_1" sizes="[[160,160],[300,80]]" delay="200")
						div
							sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_2" sizes="[[160,160],[300,80]]" delay="200")
						div
							sfc-dfp-ad(ad-unit="savingforcollege_other_right_text_3" sizes="[[160,160],[300,80]]" delay="200")
					section.sponsor-center
						h3(v-show="showSponsorCenterTitle") SPONSOR CENTER
						div
							sfc-dfp-ad(ad-unit="savingforcollege_other_right_sponsor_1" sizes="[[160,160]]" delay="300")
						div
							sfc-dfp-ad(ad-unit="savingforcollege_other_right_sponsor_2" sizes="[[160,160]]" delay="300")
						div
							sfc-dfp-ad(ad-unit="savingforcollege_other_right_sponsor_3" sizes="[[160,160]]" delay="300")

					section.sidebar-large
						sfc-dfp-ad(ad-unit="savingforcollege_other_right_wide_skyscraper_300x250" sizes="[[300, 250]]")
					.clearfix

				section.quicklinks(v-if="isWhatIsFlow && displayBestPlans")
					h2 Best 529 Plans of 2019
					.quicklinks-table
						.table-row
							.col.best-rated
								a(href="/intro-to-529s/which-is-the-best-529-plan-available#best-rated-row" @click="trackCategoryClick('Best Rated', 'Top Boxes')")
									b-img-lazy.link-image(:src="`https://web-resources.savingforcollege.com/images/icon-best-rated-color%402x.png`" alt="Best Rated")
									.link-text Best Rated
							.col.best-state-plan
								a(href="/intro-to-529s/which-is-the-best-529-plan-available#best-state-row" @click="trackCategoryClick('Best My State', 'Top Boxes')")
									b-img-lazy.link-image(:src="`https://web-resources.savingforcollege.com/images/icon-flag-color%402x.png`" alt="Best Plan For My State")
									.link-text Best Plan for my State
						.table-row.last
							.col.lowest-fees
								a(href="/intro-to-529s/which-is-the-best-529-plan-available#lowest-fees-row" @click="trackCategoryClick('Lowest Fees', 'Top Boxes')")
									b-img-lazy.link-image(:src="`https://web-resources.savingforcollege.com/images/icon-lowest-fees-color%402x.png`" alt="Lowest Fees")
									.link-text Lowest Fees
							.col.best-one
								a(href="/intro-to-529s/which-is-the-best-529-plan-available#best-perf-row" @click="trackCategoryClick('Best Performance', 'Top Boxes')")
									b-img-lazy.link-image(:src="`https://web-resources.savingforcollege.com/images/icon-best%20performing%402x.png`" alt="Best Performance")
									.link-text Best Performance
					a.simple(href="/intro-to-529s/which-is-the-best-529-plan-available") View all Categories

				section.toc-container(v-if="isWhatIsFlow")
					.youtube-video-container(v-if="$route.path.indexOf('name-the-top-7-benefits-of-529-plans') != -1")
						sfc-youtube(id="6jGr4_J726A" image="maxresdefault")
					.youtube-video-container(v-if="$route.path.indexOf('what-is-a-529-plan') != -1")
						sfc-youtube(id="_Iqf9FpfOjw" image="maxresdefault")
					div.toc-row
						span(v-show="tableOfContentsVersion == 'v1'")
							table-of-contents-v1(:content="info")
						span(v-show="tableOfContentsVersion == 'v2'")
							table-of-contents-v2(:content="info" :full="true")
				.related-performances(v-if="isPerformanceRankingPage")
					h2 Performance Rankings
					ul
						li(v-for="performance in info.related_performances")
							a(:href="performance.url")
								span.count {{performance.performance}}
								span.title {{performance.title}}
				.clearfix
				slot
		div(v-else)
			no-ssr
				.sidebar-content#latest-articles
					.section
						h3
							| Latest Articles
						span(v-for="article of articles" )
							a.article-content(:href="`${$store.state.config.sfcHost}/article/${article.slug}`")
								.article-title(v-html="article.title.rendered")
								p(v-html="article.excerpt.rendered")
								p.author(v-show="article.author_name && article.author_name != ''") by {{article.author_name}}
						.more-articles
							a(href="/articles/all") More articles
</template>
<style lang="stylus">
	.toc-container
		.youtube-video-container
			iframe
				height: 100%
				min-height: 180px
				max-width: 100%
				width: 100%
				margin-bottom: -8px
</style>
<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

aside.ads
	padding-top: 30px
	padding-bottom: 20px
	position: relative

.merril-banner-separator
	display none
	height 1px
	margin-top 20px
	margin-bottom 20px
	border-bottom 1px solid sfc-pale-gray
	position relative
	left -16px
	width calc(100% + 16px)
.merril-banner
	display none
	max-width 300px
	margin-left auto
	margin-right 0
	margin-bottom 50px
	h3
		margin-bottom 15px
		font-size: body-font-size-sm
		font-weight: body-font-weight
.article-content
	padding: 15px 0
	text-decoration: none
	.article-title
		text-decoration: none
		font-size: body-font-size-md
		margin-bottom: 15px
		color: body-font-color
	p
		text-decoration: none!important
		font-size: body-font-size-sm
		color: body-font-color
	.article-author
		color: #A9B4C2
		text-decoration: none!important
	&:hover
		.article-title
			text-decoration: underline!important
		p
			text-decoration: none!important
		.article-author
			text-decoration: none!important
			padding-top: 15px

.related-performances
	clear:both
	max-width: 300px
	float: right
	h3
		font-size: body-font-size-lg

		margin-bottom: 15px
	ul
		padding: 0
		list-style: none
		li
			display: block
			clear: both
			width: 100%
			a
				display: block
				clear: both
				vertical-align: middle
				padding: 10px 0
				border-bottom: 1px solid sfc-pale-gray

				span.count
					font-size: body-font-size-xl

					display: inline-block
					color: sfc-pale-gray
					width: 15%
					vertical-align: middle
				span.title
					font-size: body-font-size-lg
					padding-left: 15px
					display: inline-block
					color: body-font-color
					transition-all()
					width: 85%
					vertical-align: middle
				&:hover
					span.title
						color: sfc-blue

.youtube-video-container
	border: 1px solid #444
.toc-container
	padding: 0
	clear: both
	max-width: 300px
	float: right
	margin-top: 60px
	top: 90px
	position: sticky
	.toc-row
		padding-top: 15px
		h3
			font-size: body-font-size-lg
			.row-image
				height: 30px
				width: 30px
				display: inline-block
				margin-right: 15px
				position: relative
				top: 7px

.quicklinks
	clear: both
	max-width: 300px
	width: 300px
	float: right
	a.simple
		margin-top: 15px
		color: #464646
		text-decoration: underline
		display: block
	.quicklinks-table
		clear: both
		border: 1px solid sfc-pale-gray
		display: block
		.table-row
			display: flex
			clear: both
			&:first-child
				border-bottom: 1px solid sfc-pale-gray
			.col
				width: 150px
				height: 150px
				padding: 0
				&:first-child
					border-right: 1px solid sfc-pale-gray
				a
					display: block
					padding: 10px
					color: body-font-color
					width: 100%
					height: 100%
					cursor: pointer
					text-align: center

					border: 1px solid transparent
					font-size: body-font-size-sm
					&:hover
						text-decoration: none
						background: bg-gray
						border: 1px solid #444
					img
						display: block
						margin: 0 auto
						padding-top: 20px
						padding-bottom: 10px
						height: 55%
						margin-top: 10px

.sidebar-large
.text-ads
	float: right

.sponsor-center
	max-width: 300px
	width: 300px
	padding-top: 30px
	float: right
	> div
		margin: 15px auto
		width: 100%
		padding: 15px
		iframe
			margin: 0 auto
.text-ads
	> div
		margin-top: 15px

#latest-articles
	padding-top 45px
	h3
		padding-bottom: 15px
		margin-bottom: 20px
		border-bottom: 1px solid #ced3e1
	span
		display: block
		margin-bottom: 20px
	.article-title
		font-weight: body-font-weight-strong
	p
		margin-bottom: 10px
	p.author
		color: #a3a5ad
		margin-bottom: 25px
	.more-articles
		text-align: right
		a
			text-decoration: underline

.img-container
	img
		width: 225px
</style>


<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service.js"
	import TableOfContentsV1 from '@/common/components/experiments/table-of-contents/toc_v1.vue'
	import TableOfContentsV2 from '@/common/components/experiments/table-of-contents/toc_v2.vue'

	export default {
		components:{
			TableOfContentsV1,
			TableOfContentsV2

		},

		async mounted(){
			this.checkTableOfContents()
			if(this.userSubscribed()){
				try {
					const wpApiUrl = `${this.$store.state.config.wordpressApiUrl}/article`
					const params = {
					per_page: "3",
					_fields: 'id,title,slug,excerpt,author,date,author_name'
					}
					const response = await this.$httpService.get(wpApiUrl, params)
					this.articles = response
				} catch (e) {
					console.log(e)
					return
				}
			}
			if (this.$route.params.year) {
				this.bestPerformanceYear = this.$route.params.year
			}
			setTimeout(() => {
				this.showSponsorCenterTitle = true
			}, 2000)
		},
		props:[`isWhatIsFlow`, `info`, `isPerformanceRankingPage`, `displayBestPlans`],

		data(){
			return {
				ready: true,
				tableOfContentsVersion: "",
				bestPerformanceYear: '1-year',
				articles: [],
				showSponsorCenterTitle: false
			}
		},

		methods:{
			trackCategoryClick(category_name, section){
				SfcTrackingService.trackCategoryClick("Intro to 529", this.$store.state.config.introTo529sVersion, category_name, section, this.info.whatIsTitle)
			},
			goToTop(page){
				if(page){
					window.scroll(0,0)
				}
			},
			checkTableOfContents(){
				if(this.tableOfContentsVersion != ""){
					return
				}
				this.tableOfContentsVersion = "v1"
				setTimeout( () =>{
					this.checkTableOfContents()
				}, 200)
			},
			userSubscribed(){
				return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
			}
		}

	}
</script>
